import creditCardType from "credit-card-type/dist/index";
import { CreditCardType } from "credit-card-type/dist/types";

/**
 * Helper functions for RawCreditCardInput
 *
 * Cards visa master etc can have different kind of formatting
 * Using the card-type library to we the numbers which indicate the gaps/spaces which is card gaps
 * Formatting is done based on these numbers
 *
 * Link: https://www.npmjs.com/package/credit-card-type
 */
export const formatCardNumber = (formattedCardNumber: string, card: CreditCardType) => {
    if (card) {
        const cardNumber = formattedCardNumber.replace(/\s/g, "");
        const cardMaxLength = card.lengths.at(-1) ?? cardNumber.length - 1;

        if (cardNumber.length > (cardMaxLength ?? Number.MAX_SAFE_INTEGER)) {
            return formattedCardNumber.slice(0, Math.max(0, cardMaxLength - 1));
        }

        // There are some spaces in a credit card. gaps is there same spaces, read this for more info https://www.npmjs.com/package/credit-card-type
        const offsets = [...([] as number[]), 0, ...card.gaps, cardNumber.length];
        const components = [];

        for (let index = 0; offsets[index] < cardNumber.length; index++) {
            const start = offsets[index];
            const end = Math.min(offsets[index + 1], cardNumber.length);
            components.push(cardNumber.slice(start, end));
        }

        return components.join(" ");
    }

    return formattedCardNumber;
};

/**
 * Gets the Credit card type of the card based on card number
 */
export const getCreditCardType = (cardNumber: string) => {
    const cardType = creditCardType(cardNumber);
    if (cardType.length > 0 && cardNumber.length > 0) {
        // cardType will be something like visa, mastercard
        return cardType[0];
    }

    return null;
};

export const getCompatibleCardType = (cardType: string) => {
    const amexRegex = /^american\s*express$/i;
    const dinersRegex = /^diners-club$/i;

    if (amexRegex.test(cardType)) {
        return "amex";
    }

    if (dinersRegex.test(cardType)) {
        return "diners";
    }

    return cardType;
};
